export default __webpack_public_path__ + "static/media/load1.d43db8d5.gif";